import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import _ from 'underscore';
import styles from './index.module.scss';
import { stringifySearch } from '../../../../utils';

function BreadCrumb() {

  const history = useHistory();
  const { pathname } = useLocation();

  const {
    crumb,
    urlParams,
    categorys,
    searchLoading
  } = useSelector(state => state.searchReducer);

  const handleCancelAllCrumb = (e) => {
    e.stopPropagation();
    let _searchParamsBody = _.pick(urlParams, ['keyword', 'searchkey', 'searchAll', 'cid2', 'cid3']);
    history.push({
      pathname,
      search: stringifySearch(_searchParamsBody)
    })
  }

  const handleCancelCrumb = _.debounce((crumbName, crumbId, e) => {
    e.stopPropagation();
    const _searchParamsBody = JSON.parse(JSON.stringify(urlParams));
    if (crumbName !== '品牌') {
      _searchParamsBody.extAttrs = _searchParamsBody.extAttrs.filter(item => !(crumbId == item));
    } else {
      // const crumbIdArr = crumbId[0].split('||');
      // _searchParamsBody.brands = _searchParamsBody.brands.filter(item => crumbIdArr.includes(item));
      if (window.location.pathname.indexOf('list.html') !== -1) {
        delete _searchParamsBody.ev
      }else{
        _searchParamsBody.brands = [];
      }
    }
    history.push({
      pathname,
      search: stringifySearch(_searchParamsBody)
    })
  }, 1000)

  if(searchLoading) return null

  return (
    <div className="w">
      <div className={`${styles["crumbs-bar"]} clearfix`}>
        <div className={styles["crumbs-nav"]}>
          <div className={styles.item}>
            <span className={styles["crumbs-link"]} onClick={handleCancelAllCrumb}>全部结果</span>
            <i className={styles["crumbs-arrow"]}>&gt;</i>
          </div>


          {
            crumb.map(item => {
              const content = item?.content;
              const str = Array.isArray(content) ? content.join('、') : '';
              return (
                <div className={styles.item} key={item.crumbName}>
                  <div className={styles["selector-set"]}>
                    <span href="" className={styles["ss-item"]} title={str}>
                      <b>{item.crumbName}：</b>
                      <em>
                        {str?.length < 20 ? str : str?.slice(0, 20)}
                      </em>
                      <i onClick={(e) => handleCancelCrumb(item.crumbName, item.id, e)}></i>
                    </span>
                    <i className="crumbs-arrow">&gt;</i>
                  </div>
                </div>
              )
            })
          }

          <div className={styles.item}>
            <b>
              {
                window.location.pathname.indexOf('list.html') !== -1 || window.location.hostname === 'list.jd.hk' ?
                  (
                    categorys?.[1]?.cid3[0]?.name 
                    // || categorys[0]?.cid2[0]?.name
                  ) :
                  urlParams.keyword
              }
            </b>
          </div>

        </div>

        {
          crumb.length > 0 && <span className={`${styles["btn-default"]} fr`} onClick={handleCancelAllCrumb}>全部撤消</span>
        }
      </div>
    </div>
  )
}

export default BreadCrumb;